import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  useToast,
  Td,
  Select,
  Button,
  HStack,
  Badge,
  IconButton,
  Flex,
  Stack,
  Spinner,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DeleteIcon } from "@chakra-ui/icons";
import Rout_edit from "./Rout_edit";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Rout_Table = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Modal open state
  const [routeIdToDelete, setRouteIdToDelete] = useState(null); // Store the route id to delete

  const toast = useToast();
  const navigate = useNavigate();

  const schoolId = sessionStorage.getItem("school_id");

  useEffect(() => {
    fetchData();
  }, []);

  const RefreshData = () => {
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/bus_route/list_all_bus_route.php?school_id=${schoolId}`
      );

      const result = await response.json();
      console.log("l r", result);

      if (response.ok && result.success) {
        const formattedData = result.data.map((item) => ({
          id: item.route_id,
          bus: item.bus_no || "N/A",
          end: item.end_place || "Unknown",
          start: item.start_place || "Unknown",
          status: item.status || "Inactive",
          date: item.added_on || "N/A",
          pickup: item.stops || [],
        }));
        setData(formattedData);
      } else {
        throw new Error(result.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(data.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const currentData = data.slice(startIndex, startIndex + entriesPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {
      const userId = sessionStorage.getItem("user_id");

      if (!userId || !schoolId) {
        toast({
          title: "Error",
          description: "User ID or School ID is missing.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const response = await axios.delete(
        `${BASE_URL}/admin/bus/bus_route/delete_bus_route.php`,
        {
          data: {
            user_id: userId,
            school_id: schoolId,
            id: routeIdToDelete,
          },
        }
      );

      if (response.data.success) {
        toast({
          title: "Success",
          description: "Bus route deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchData(); // Refresh data
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to delete",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description:
          "Stops are assigned to this route name. Cannot delete the Route name.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setIsDeleteModalOpen(false); // Close the modal after deletion
  };

  return (
    <Box>
      <HStack justifyContent="space-between" className="sb" p={3}>
        <Box>
          <HStack>
            <Select
              width="120px"
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="70">70</option>
            </Select>
          </HStack>
        </Box>
      </HStack>

      {loading ? (
        <Flex justify="center" align="center" minH="200px">
          <Spinner size="xl" />
        </Flex>
      ) : error ? (
        <Flex justify="center" align="center" minH="200px">
          <Text color="red.500">{error}</Text>
        </Flex>
      ) : (
        <>
          <Box overflowX="auto" maxWidth="100%">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
              colorScheme="gray"
            >
              <Thead>
                <Tr>
                  <Th>
                    <Box textAlign="center">Bus</Box>{" "}
                  </Th>
                  <Th>
                    <Box textAlign="center">Route</Box>
                  </Th>
                  {/* <Th>To</Th> */}

                  <Th>
                    <Box textAlign="center">Pickup Points</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Status</Box>
                  </Th>
                  <Th>
                    <Box textAlign="center">Action</Box>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((item) => (
                  <Tr key={item.id}>
                    <Td>
                      <Box textAlign="center">
                        <Button
                          variant="link"
                          colorScheme="teal"
                          onClick={() =>
                            navigate(`/bus/allocate_students/${item.id}`)
                          }
                        >
                          {item.bus}
                        </Button>
                      </Box>
                    </Td>
                    <Td>
                      <Box textAlign="center">
                        {item.end} - {item.start}
                      </Box>
                    </Td>

                    <Td>
                      <Box textAlign="center">
                        {item.pickup.map((place, index) => (
                          <Box key={index} mb={2}>
                            {/* Stop Name and Fee on the First Line */}
                            <Text fontWeight="bold">
                              {place.stop_name}{" "}
                              <Text as="span" color="teal.500">
                                Fee: {place.fee_amount}
                              </Text>
                            </Text>

                            {/* Pickup and Drop Time on the Second Line */}
                            <Text fontSize="sm" color="gray.500">
                              Pickup: {place.pickup_time} | Drop:{" "}
                              {place.drop_time}
                            </Text>
                          </Box>
                        ))}
                      </Box>
                    </Td>

                    <Td>
                      <Box textAlign="center">
                        <Badge
                          borderRadius="full"
                          fontSize="10px"
                          colorScheme={item.status === 1 ? "green" : "green"}
                        >
                          {item.status === 1 ? "Active" : "Active"}
                        </Badge>
                      </Box>
                    </Td>
                    <Td textAlign="center">
                      <Stack direction="row" spacing={2} justify="center">
                        <Rout_edit
                          route_id={item.id}
                          RefreshData={RefreshData}
                        />
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          size="sm"
                          onClick={() => {
                            setRouteIdToDelete(item.id);
                            setIsDeleteModalOpen(true);
                          }}
                          aria-label="Delete"
                        />
                      </Stack>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          <Flex justify="end" align="center" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                >
                  {i + 1}
                </Button>
              ))}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>

          {/* Confirmation Modal */}
          <Modal
            isOpen={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(false)}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Delete Bus Route</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text>Are you sure you want to delete this bus route?</Text>
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="ghost"
                  onClick={() => setIsDeleteModalOpen(false)}
                >
                  Cancel
                </Button>
                <Button colorScheme="red" onClick={handleDelete}>
                  Delete
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}
    </Box>
  );
};

export default Rout_Table;
